import { useEffect} from "react";
import ReactPortal from "../utils/protal";
import { CloseRounded } from "@mui/icons-material";
import Thumbnail from "../components/thumbnail";
import SpinLoader from "../components/spin-loader";

function Player({item, widget, settings, onClose}) {
  useEffect(() => {
    document.body.style.overflow="hidden";
    const closeOnEscapeKey = (e) =>
      e.key === "Escape" ? onClose() : null;
    document.body.addEventListener("keydown", closeOnEscapeKey);
    return () => {
      document.body.removeEventListener("keydown", closeOnEscapeKey);
      document.body.style.overflow="initial";
    };
  }, [onClose]);
    return (
      <ReactPortal>
        <div className="vf-player fixed top-0 left-0 w-screen h-screen z-50 flex justify-center items-start md:items-center md:px-5">
          <div onClick={onClose} className="vf-player-backdrop absolute top-0 left-0 w-screen h-screen bg-[rgba(0,0,0,0.85)] z-10"></div>
          <div className="flex flex-col w-full xl:w-2/3 z-20">
            <div className="flex justify-between py-2 px-1 bg-black md:bg-transparent md:px-0 md:py-0 md:mb-1 items-center">
              <span className="vf-player-title text-white font-bold text-sm sm:text-base md:text-lg mr-3">{item.name}</span>
              <div className="flex">
                <CloseRounded
                  fontSize="medium"
                  className="vf-player-close text-white/70 hover:text-white cursor-pointer"
                  onClick={onClose}
                />
              </div>
            </div>
            <div className="w-full pt-16/9 relative bg-black overflow-hidden" >
              <Thumbnail className="absolute top-0 left-0 opacity-50 blur-lg" item={item} settings={settings}/>
              <SpinLoader className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[50px] h-[50px]"/>
              <iframe
                // src={`http://localhost:3002/widget/${widget}/player/${item.id}`}
                src={`https://www.videoflow.io/widget/${widget}/player/${item.id}`}
                title="{data.name}"
                className="absolute w-full h-full top-0 left-0"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </ReactPortal>
    );
}

export default Player;
